import { render, staticRenderFns } from "./EncounterArchive.vue?vue&type=template&id=045d0d8f"
import script from "./EncounterArchive.vue?vue&type=script&lang=js"
export * from "./EncounterArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Dev\\WorldManager\\src\\WorldManager.Web\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('045d0d8f')) {
      api.createRecord('045d0d8f', component.options)
    } else {
      api.reload('045d0d8f', component.options)
    }
    module.hot.accept("./EncounterArchive.vue?vue&type=template&id=045d0d8f", function () {
      api.rerender('045d0d8f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/encounter/EncounterArchive.vue"
export default component.exports